import { ADMIN_TABS, AdminTab } from './adminTabs';
import { Link } from 'react-router-dom';
import './AdminHome.css';

export const AdminSidebar = ({
  activeTab,
  onNavigate
}: {
  activeTab: AdminTab;
  onNavigate: (path: string) => void;
}) => {
  return (
    <aside className="admin-sidebar">
      <h1 className="admin-sidebar-title">Adminpanel</h1>

      {/* MAIN NAV */}
      <nav className="admin-nav">
        {ADMIN_TABS.map(tab => (
          <button
            key={tab.id}
            className={`admin-nav-item ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onNavigate(tab.path)}
          >
            <tab.icon size={20} className="admin-nav-item-icon" />
            <span>{tab.label}</span>
          </button>
        ))}
      </nav>

      {/* FOOTER LINK */}
      <div className="admin-sidebar-footer">
        <Link to="/" className="admin-sidebar-backlink">
          ← Tillbaka till portalen
        </Link>
      </div>
    </aside>
  );
};
